import React, { useState } from 'react';
import { PropTypes, describe } from '@elliemae/ds-props-helpers';
import RWInfiniteLoader from 'react-window-infinite-loader';
import { VariableSizeList as List } from 'react-window';

const VirtualizedInfiniteLoader = ({
  moreItemsLoading = false,
  hasNextPage = false,
  isItemLoaded = () => true,
  loadMoreItems,
  getItemSize = () => 38,
  height,
  item: Row,
}) => {
  const [itemCount, setItemCount] = useState(10);

  const loadMore = (startIndex, stopIndex) => {
    if (hasNextPage) setItemCount(itemCount + 1);
    return loadMoreItems(startIndex, stopIndex);
  };

  return (
    <div style={{ position: 'relative' }}>
      <RWInfiniteLoader isItemLoaded={isItemLoaded} itemCount={itemCount} loadMoreItems={loadMore}>
        {({ onItemsRendered, ref }) => (
          <List
            className="List"
            height={height}
            itemCount={itemCount}
            itemSize={getItemSize}
            onItemsRendered={onItemsRendered}
            ref={ref}
            width="100%"
          >
            {Row}
          </List>
        )}
      </RWInfiniteLoader>
      {moreItemsLoading && (
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            background: 'blue',
            zIndex: 1,
          }}
        >
          Loading
        </div>
      )}
    </div>
  );
};

const listProps = {
  /** Function responsible for tracking the loaded state of each item. */
  isItemLoaded: PropTypes.bool.description('Function responsible for tracking the loaded state of each item.'),
  /**  Callback to be invoked when more rows must be loaded. It should return a Promise that is resolved once all data has finished loading. */
  loadMoreItems: PropTypes.func.description(
    'Callback to be invoked when more rows must be loaded. It should return a Promise that is resolved once all data has finished loading.',
  ),
  /** callback to get row item size */
  getItemSize: PropTypes.func.description('callback to get row item size'),
  /** height for the list */
  height: PropTypes.number.description('height for the list'),
  /** flag to know if virtual list should be on loading state */
  moreItemsLoading: PropTypes.bool.description('flag to know if virtual list s'),
  /** Row item to render */
  item: PropTypes.element.description('Row item to render'),
  /** flag for virtualized list */
  hasNextPage: PropTypes.bool.description('flag for virtualized list'),
};

VirtualizedInfiniteLoader.displayName = 'VirtualizedInfiniteLoader';
const VirtualizedInfiniteLoaderWithSchema = describe(VirtualizedInfiniteLoader);

VirtualizedInfiniteLoaderWithSchema.propTypes = listProps;

export { VirtualizedInfiniteLoader, VirtualizedInfiniteLoaderWithSchema };
